import { useState } from "react";
import {
  useCreateRole,
  useFetchRoles,
} from "../../../hooks/api/users/useRoles";

export const useRolesLogic = () => {
  const [filters, setFilters] = useState<Filters>({
    pageSize: 10,
    searchTerm: "",
    pageNumber: 1,
  });
  const handleSearchTerm = (e: React.ChangeEvent<HTMLInputElement>) => {
    setFilters((prev) => ({ ...prev, searchTerm: e.target.value }));
  };
  const rolesList = useFetchRoles(filters);
  const createRole = useCreateRole();
  return { rolesList, createRole, setFilters, handleSearchTerm };
};
export default useRolesLogic;
